/* eslint-disable no-console */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { Controller } from 'react-hook-form';
import PlacesAutocomplete from 'react-places-autocomplete';
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from '@material-ui/core';
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input';

export const getId = (label) => {
  return label.replaceAll(' ', '_');
};

export const getAddressDetails = async (countryId, callBack) => {
  await fetch('/corbapi/reactforms/getcountryinfo', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      countryId: countryId,
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data?.data) {
        callBack(data.data);
      }
    })
    .catch((e) => {
      console.log(e);
    });
};

export const getReactField = (
  field,
  jsonData,
  zipFormat,
  countryCode,
  control,
  googleAddress,
  handleChange,
  handleSelect,
  autocompletionRequestJson,
  watch,
  stateRequired,
  zipRequired,
  zipRegEx,
  zipLabel,
  countryInfoCallBack,
  setGoogleAddress,
  resetField,
  examplePhone,
  disableGoogleLookup,
  useFormattedAddressField,
  ii
) => {
  const maxLength = field.maxLength <= 0 ? 'undefined' : field.maxLength;
  const autoComplete = field.autoComplete ? 'on' : 'off';
  const format = field.label === jsonData.zipField ? zipFormat : undefined;
  if (field.label === jsonData.phoneField && countryCode !== 'OTHER') {
    return (
      <div key={ii} className={`section-field`}>
        <Controller
          name={`${getId(field.label)}-country`}
          control={control}
          rules={{
            required:
              field.label === jsonData.stateField
                ? stateRequired
                : field.label === jsonData.zipField
                ? zipRequired
                : field.required,
            pattern:
              field.label === jsonData.zipField &&
              zipRegEx !== null &&
              zipRegEx !== ''
                ? new RegExp(zipRegEx)
                : field.regEx && field.regEx !== ''
                ? new RegExp(field.regEx)
                : '',
            validate: (value) =>
              countryCode === 'OTHER' ||
              matchIsValidTel(value, { onlyCountries: [countryCode] }),
          }}
          render={({
            field: { onChange, onBlur, ref },
            fieldState: { error },
          }) => (
            <MuiTelInput
              disabled={
                typeof countryCode === 'undefined' ||
                countryCode === null ||
                countryCode === ''
              }
              defaultCountry={countryCode}
              forceCallingCode={true}
              disableDropdown={true}
              fullWidth
              size="small"
              type={field.htmlFieldType}
              label={
                field.label === jsonData.zipField &&
                zipLabel !== null &&
                zipLabel !== ''
                  ? zipLabel
                  : field.label
              }
              variant="outlined"
              inputProps={{
                maxLength,
                autoComplete: autoComplete,
                'data-title': field.gaTaggingEnabled
                  ? field.gaTaggingTitle
                  : undefined,
                'data-text': field.gaTaggingEnabled
                  ? watch(`${getId(field.label)}-country`)
                  : undefined,
              }}
              id={`ctrl${getId(field.label)}-country`}
              helperText={
                error
                  ? field.errorMessage
                  : typeof examplePhone !== 'undefined' &&
                    examplePhone !== null &&
                    examplePhone !== ''
                  ? examplePhone
                  : typeof field.helpText !== 'undefined' &&
                    field.helpText !== null &&
                    field.helpText !== ''
                  ? field.helpText
                  : typeof format !== 'undefined' &&
                    format !== null &&
                    format !== ''
                  ? `Should be in the format ${format.replaceAll('|', ' or ')}`
                  : ''
              }
              onChange={onChange}
              onBlur={onBlur}
              error={!!error}
              value={watch(`${getId(field.label)}-country`)}
              ref={ref}
            />
          )}
        />
      </div>
    );
  }

  if (
    (useFormattedAddressField === true &&
      (field.label === jsonData.address2Field ||
        field.label === jsonData.cityField ||
        field.label === jsonData.stateField ||
        field.label === jsonData.zipField)) ||
    (useFormattedAddressField === true &&
      disableGoogleLookup === true &&
      field.label === jsonData.address1Field)
  ) {
    return <></>;
  }

  if (
    useFormattedAddressField === true &&
    field.label === jsonData.fullAddressField
  ) {
    return (
      <div key={ii} className={`section-field`}>
        <Controller
          name={getId(field.label)}
          control={control}
          rules={{
            required: field.required,
            pattern:
              field.regEx && field.regEx !== '' ? new RegExp(field.regEx) : '',
          }}
          render={({
            field: { onChange, value, onBlur, ref },
            fieldState: { error },
          }) => (
            <>
              <TextField
                fullWidth
                size="small"
                type="text"
                label={field.label}
                variant="outlined"
                inputProps={{
                  maxLength,
                  'data-title': field.gaTaggingEnabled
                    ? field.gaTaggingTitle
                    : undefined,
                  'data-text': field.gaTaggingEnabled
                    ? watch(getId(field.label))
                    : undefined,
                  // readOnly: disableGoogleLookup === false,
                }}
                multiline
                minRows={4}
                maxRows={Infinity}
                id={`ctrl${getId(field.label)}`}
                onChange={onChange}
                error={!!error}
                value={watch(getId(field.label))}
                onBlur={onBlur}
                inputRef={ref}
              />
              <FormHelperText
                margin="dense"
                className={`MuiFormHelperText-contained ${
                  error ? 'Mui-error' : ''
                }`}
              >
                <span className="messages">
                  {error ? field.errorMessage : field.helpText}
                </span>
                <span className="show-count">{`${
                  value?.length ?? 0
                }/${maxLength}`}</span>
              </FormHelperText>
            </>
          )}
        />
      </div>
    );
  }

  if (
    field.fieldType === 'Text' &&
    disableGoogleLookup === false &&
    field.googleAutoComplete === true &&
    typeof countryCode !== 'undefined' &&
    countryCode !== null &&
    countryCode !== ''
  ) {
    return (
      <div key={ii} className={`section-field`}>
        <Controller
          name={getId(field.label)}
          control={control}
          rules={{
            required: useFormattedAddressField ? false : field.required,
            pattern:
              field.regEx && field.regEx !== '' ? new RegExp(field.regEx) : '',
          }}
          render={({
            field: { onChange, onBlur, ref },
            fieldState: { error },
          }) => (
            <PlacesAutocomplete
              value={googleAddress}
              onChange={handleChange}
              onSelect={handleSelect}
              searchOptions={autocompletionRequestJson}
            >
              {({
                getInputProps,
                suggestions,
                getSuggestionItemProps,
                loading,
              }) => (
                <div>
                  <TextField
                    fullWidth
                    size="small"
                    type={field.htmlFieldType}
                    label={
                      useFormattedAddressField ? 'Address Lookup' : field.label
                    }
                    variant="outlined"
                    inputProps={{
                      maxLength,
                      autoComplete: autoComplete,
                      format: format,
                      'data-title': field.gaTaggingEnabled
                        ? field.gaTaggingTitle
                        : undefined,
                      'data-text': field.gaTaggingEnabled
                        ? watch(getId(field.label))
                        : undefined,
                    }}
                    id={`ctrl${getId(field.label)}`}
                    helperText={error ? field.errorMessage : field.helpText}
                    onChange={onChange}
                    onBlur={onBlur}
                    error={!!error}
                    value={watch(getId(field.label))}
                    ref={ref}
                    {...getInputProps({
                      className: 'location-search-input',
                    })}
                  />
                  <div className="autocomplete-dropdown-container">
                    {loading && <div>Loading...</div>}
                    {suggestions.map((suggestion, i) => {
                      const className = suggestion.active
                        ? 'suggestion-item--active'
                        : 'suggestion-item';
                      // inline style for demonstration purpose
                      const style = suggestion.active
                        ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                        : { backgroundColor: '#ffffff', cursor: 'pointer' };
                      return (
                        <div
                          key={i}
                          {...getSuggestionItemProps(suggestion, {
                            className,
                            style,
                          })}
                        >
                          <span>{suggestion.description}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </PlacesAutocomplete>
          )}
        />
      </div>
    );
  }

  if (field.fieldType === 'Hidden') {
    return (
      <div key={ii} className={`section-field section-field-hidden`}>
        <Controller
          name={getId(field.label)}
          control={control}
          render={({
            field: { onChange, onBlur, ref },
            fieldState: { error },
          }) => (
            <TextField
              fullWidth
              size="small"
              type="hidden"
              variant="outlined"
              id={`ctrl${getId(field.label)}`}
              onChange={onChange}
              onBlur={onBlur}
              error={!!error}
              value={watch(getId(field.label))}
              ref={ref}
            />
          )}
        />
      </div>
    );
  }
  if (field.fieldType === 'Text') {
    return (
      <div key={ii} className={`section-field`}>
        <Controller
          name={getId(field.label)}
          control={control}
          rules={{
            required:
              field.label === jsonData.stateField
                ? stateRequired
                : field.label === jsonData.zipField
                ? zipRequired
                : field.required,
            pattern:
              field.label === jsonData.zipField &&
              zipRegEx !== null &&
              zipRegEx !== ''
                ? new RegExp(zipRegEx)
                : field.regEx && field.regEx !== ''
                ? new RegExp(field.regEx)
                : '',
          }}
          render={({
            field: { onChange, onBlur, ref },
            fieldState: { error },
          }) => (
            <TextField
              disabled={
                (typeof countryCode === 'undefined' ||
                  countryCode === null ||
                  countryCode === '') &&
                (field.label === jsonData.address1Field ||
                  field.label === jsonData.address2Field ||
                  field.label === jsonData.countryField ||
                  field.label === jsonData.cityField ||
                  field.label === jsonData.stateField ||
                  field.label === jsonData.zipField)
              }
              fullWidth
              size="small"
              type={field.htmlFieldType}
              label={
                field.label === jsonData.zipField &&
                zipLabel !== null &&
                zipLabel !== ''
                  ? zipLabel
                  : field.label
              }
              variant="outlined"
              inputProps={{
                maxLength,
                autoComplete: autoComplete,
                'data-title': field.gaTaggingEnabled
                  ? field.gaTaggingTitle
                  : undefined,
                'data-text': field.gaTaggingEnabled
                  ? watch(getId(field.label))
                  : undefined,
              }}
              id={`ctrl${getId(field.label)}`}
              helperText={
                error
                  ? field.errorMessage
                  : typeof field.helpText !== 'undefined' &&
                    field.helpText !== null &&
                    field.helpText !== ''
                  ? field.helpText
                  : typeof format !== 'undefined' &&
                    format !== null &&
                    format !== ''
                  ? `Should be in the format ${format.replaceAll('|', ' or ')}`
                  : ''
              }
              onChange={onChange}
              onBlur={onBlur}
              error={!!error}
              value={watch(getId(field.label))}
              ref={ref}
            />
          )}
        />
      </div>
    );
  }
  if (field.fieldType === 'Area') {
    return (
      <div key={ii} className={`section-field`}>
        <Controller
          name={getId(field.label)}
          control={control}
          rules={{
            required: field.required,
            pattern:
              field.regEx && field.regEx !== '' ? new RegExp(field.regEx) : '',
          }}
          render={({
            field: { onChange, value, onBlur, ref },
            fieldState: { error },
          }) => (
            <>
              <TextField
                fullWidth
                size="small"
                type="text"
                label={field.label}
                variant="outlined"
                inputProps={{
                  maxLength,
                  'data-title': field.gaTaggingEnabled
                    ? field.gaTaggingTitle
                    : undefined,
                  'data-text': field.gaTaggingEnabled
                    ? watch(getId(field.label))
                    : undefined,
                }}
                multiline
                minRows={2}
                maxRows={Infinity}
                id={`ctrl${getId(field.label)}`}
                onChange={onChange}
                error={!!error}
                value={watch(getId(field.label))}
                onBlur={onBlur}
                inputRef={ref}
              />
              <FormHelperText
                margin="dense"
                className={`MuiFormHelperText-contained ${
                  error ? 'Mui-error' : ''
                }`}
              >
                <span className="messages">
                  {error ? field.errorMessage : field.helpText}
                </span>
                <span className="show-count">{`${value.length}/${maxLength}`}</span>
              </FormHelperText>
            </>
          )}
        />
      </div>
    );
  }
  if (field.fieldType === 'Dropdown') {
    return (
      <div key={ii} className={`section-field`}>
        <Controller
          name={getId(field.label)}
          control={control}
          rules={
            field.required
              ? {
                  required: {
                    value: field.required,
                    message: field.errorMessage,
                  },
                }
              : {}
          }
          render={({
            field: { onChange, ref, onBlur },
            fieldState: { error },
          }) => (
            <FormControl fullWidth size="small" error={!!error}>
              <InputLabel
                id={`lbl${getId(field.label)}`}
                margin="none"
                className="select-label"
              >
                {field.label}
              </InputLabel>
              <Select
                MenuProps={{
                  autoWidth: true,
                  anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                  PaperProps: { style: { maxHeight: '500px' } },
                }}
                labelId={`lbl${getId(field.label)}`}
                id={`ctrl${getId(field.label)}`}
                label={field.label}
                inputProps={{
                  'data-title': field.gaTaggingEnabled
                    ? field.gaTaggingTitle
                    : undefined,
                  'data-text': field.gaTaggingEnabled
                    ? watch(getId(field.label))
                    : undefined,
                }}
                autoWidth
                variant="outlined"
                onChange={async (e) => {
                  if (field.label === jsonData.countryField) {
                    await getAddressDetails(
                      e.target.value,
                      countryInfoCallBack
                    );
                    resetField(getId(jsonData.address1Field));
                    resetField(getId(jsonData.address2Field));
                    resetField(getId(jsonData.cityField));
                    resetField(getId(jsonData.stateField));
                    resetField(getId(jsonData.zipField));
                    resetField(getId(jsonData.fullAddressField));
                    resetField(getId(jsonData.phoneField));
                    resetField(`${getId(jsonData.phoneField)}-country`);
                    setGoogleAddress('');
                  }
                  onChange(e);
                }}
                onBlur={onBlur}
                error={!!error}
                value={watch(getId(field.label))}
                inputRef={ref}
              >
                {field.items &&
                  field.items.map((item, i) => {
                    return (
                      <MenuItem
                        key={i}
                        value={
                          field.label === jsonData.countryField
                            ? item.id
                            : item.value
                        }
                      >
                        {item.name}
                      </MenuItem>
                    );
                  })}
              </Select>
              <FormHelperText
                margin="dense"
                className={`MuiFormHelperText-contained ${
                  error ? 'Mui-error' : ''
                }`}
              >
                {error ? error.message : field.helpText}
              </FormHelperText>
            </FormControl>
          )}
        />
      </div>
    );
  }
  return <></>;
};
